module.exports = __webpack_public_path__ + "img/af.b7494e9a.svg";